<template>
  <div class="content" id="bom-tool" :class="readonly ? 'bom-snapshot' : 'bom-edit'">
    <h1>{{ pageTitle }}<span v-if="isCostEstimationPurpose" style="font-size: 80%">&nbsp;{{ $t('bom_tool.cost_estimation_use') }}</span></h1>
    <div class="content-body">
      <div class="block">
        <Row class="align-items-end">
          <Col span="24">
            <div class="margin-bottom-10">
              <div class="ribbon ribbon-top-right ribbon-snapshot" v-if="readonly"><span>Snapshot</span></div>
              <BomMainInfo :bom="bomMain" :loading="loadingBomMain" :readonly="readonly"></BomMainInfo>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span="24">
            <BOMSingleLevelView v-if="bomMain && bomItems"
                                :bom="bomMain"
                                :bom-items="bomItems"
                                :loading="loadingBomItems"
                                :readonly="readonly"
                                :is-for-cost-estimation="isCostEstimationPurpose">
            </BOMSingleLevelView>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import BomMainInfo from './components/bom-main-info'
import { BOMSingleLevelView } from './views'
export default {
  name: 'BomCompositionTool',
  components: {
    BomMainInfo,
    BOMSingleLevelView
  },
  data() {
    return {
      loadingBomMain: false,
      loadingBomItems: false,
      bomId: parseInt(this.$route.params.bomId)
    }
  },
  mounted() {
    this.loadBomMainData()
    this.loadBomItemsData()
  },
  watch: {
    '$route.params.bomId': function (id) {
      this.bomId = parseInt(this.$route.params.bomId)
    }
  },
  computed: {
    ...mapState({
      bomMain: state => state.bom.bomMain,
      bomItems: state => state.bom.bomItems
    }),
    pageTitle: function () {
      document.title = this.$t('menu.bom.edit_bom') + ' - ' + this.bomMain?.name
      return document.title
    },
    version: function () {
      return this.$route.query.version
    },
    readonly: function () {
      return this.$route.query.version !== undefined
    },
    isCostEstimationPurpose: function () {
      return this.bomMain && this.bomMain.setting && this.bomMain.setting.bom_type === 'cost_estimation_use'
    }
  },
  methods: {
    ...mapActions([
      'getBomMain',
      'getBomItems'
    ]),
    loadBomMainData () {
      if (this.bomId) {
        this.loadingBomMain = true
        this.getBomMain({ id: this.bomId, version: this.version }).finally(() => {
          this.loadingBomMain = false
        })
      }
    },
    loadBomItemsData () {
      this.loadingBomItems = true
      this.getBomItems({ id: this.bomId, version: this.version }).finally(() => {
        this.loadingBomItems = false
      })
    }
  }
}
</script>
<style lang="less" scoped>
.content { padding: 0; background: none; }
.content .table-wrapper {
  padding: 5px 25px 25px 25px;
  margin-top: 20px;
  background: #fff;
}
#bom-tool {
  h2 {width: 100%;}
  span.title {width: 120px; font-weight: bold; display: inline-block;}
  .ribbon-top-right {
    top: -10px;
    right: -33px;
    z-index: 10;
  }

  .ribbon-snapshot span {
    background-color: #c5c8ce;
  }
}
</style>
